import { Component } from 'react';
import './TimeFacetPresentation.scss';
import moment, { Moment } from 'moment';
import {
    Shifts20Regular as ShiftActivityIcon,
    ChevronDown32Filled as ChevronDownIcon,
    ChevronRight32Filled as ChevronRightIcon,
} from '@fluentui/react-icons';
import { Button, Radio, RadioGroup, Field } from '@fluentui/react-components';
import DatePicker from './DatePickerPresentation';
import { connectTeamsTheme } from './../../../context/connectTeamsTheme';
import { TimePicker } from '@fluentui/react-timepicker-compat';
import { TimeStartFacetValue } from '../../../types/Facet';

interface PeriodEntry {
    count: number;
    showAlways: boolean;
    checked: boolean;
    displayName: string;
    displaycount?: boolean;
    period: any;
    periodIndex: number;
}

interface TimeFacetTemplateProps {
    periodData: PeriodEntry[];
    displayName: string;
    name: string;
    onChangeFacet: (name: string, value: TimeStartFacetValue) => void;
    context: { style: number };
     isExecutingSearch: boolean ;
}

interface TimeFacetTemplateState {
    isExpanded: boolean;
    fromTimeEditQueue: number;
    fromDateTime: Moment;
    toTimeEditQueue: number;
    toDateTime: Moment;
    fromTimeErrorMessage: string;
    toTimeErrorMessage: string;
}

class TimeFacetTemplate extends Component<TimeFacetTemplateProps, TimeFacetTemplateState> {
    constructor(props: TimeFacetTemplateProps) {
        super(props);
        let dateTimeYesterday = moment().subtract(1, 'day');
        let dateTimeNow = moment();
        this.state = {
            isExpanded: true,
            fromTimeEditQueue: 0,
            fromDateTime: dateTimeYesterday,
            toTimeEditQueue: 0,
            toDateTime: dateTimeNow,
            fromTimeErrorMessage: '',
            toTimeErrorMessage: '',
        };
    }

    handleSectionExpand = () =>
        this.setState((prevState) => ({
            isExpanded: !prevState.isExpanded,
        }));

    dateStringToMoment = (date: string | Date) => {
        return moment(new Date(date));
    };

    reportFacetChange = (fromDateTime: Moment, toDateTime: Moment, selectedIndex: number | null) => {        
        let valueChanged = new TimeStartFacetValue(            
            this.props.name,
            selectedIndex,
            moment.duration(toDateTime.diff(fromDateTime)),            
            fromDateTime,
            toDateTime);
        this.props.onChangeFacet(this.props.name, valueChanged);
    };

    reportFromDateTimeChange = (fromDateTime: Moment, toDateTime: Moment) => {
        let dateTimeNow = moment();
        if (fromDateTime > dateTimeNow) {
            fromDateTime = dateTimeNow.subtract(1, 'day');
        }
        if (fromDateTime > toDateTime) {
            toDateTime = fromDateTime.clone().add(1, 'day');
        }
        this.reportFacetChange(fromDateTime, toDateTime, null);
    };

    reportToDateTimeChange = (fromDateTime: Moment, toDateTime: Moment) => {
        let dateTimeNow = moment();
        if (toDateTime > dateTimeNow) {
            toDateTime = dateTimeNow;
        }
        if (fromDateTime > toDateTime) {
            fromDateTime = toDateTime.clone().subtract(1, 'day');
        }
        this.reportFacetChange(fromDateTime, toDateTime, null);
    };

    onFromDateTimeChange = (fromDateTime: Moment) => {
        if (!fromDateTime || !fromDateTime.isValid() || fromDateTime > this.state.toDateTime) {
            return;
        }
        this.setState(
            (prevState) => ({
                ...prevState,
                fromDateTime,
                fromTimeEditQueue: prevState.fromTimeEditQueue + 1,
            }),
            () =>
                setTimeout(() => {
                    this.setState(
                        (prevState) => ({
                            ...prevState,
                            fromTimeEditQueue: prevState.fromTimeEditQueue - 1,
                        }),
                        () => {
                            if (this.state.fromTimeEditQueue === 0) {
                                this.reportFromDateTimeChange(fromDateTime, this.state.toDateTime);
                            }
                        }
                    );
                }, 2000)
        );
    };

    onToDateTimeChange = (toDateTime: Moment) => {
        if (!toDateTime || !toDateTime.isValid() || toDateTime < this.state.fromDateTime) {
            return;
        }
        this.setState(
            (prevState) => ({
                ...prevState,
                toDateTime,
                toTimeEditQueue: prevState.toTimeEditQueue + 1,
            }),
            () =>
                setTimeout(() => {
                    this.setState(
                        (prevState) => ({
                            ...prevState,
                            toTimeEditQueue: prevState.toTimeEditQueue - 1,
                        }),
                        () => {
                            if (this.state.toTimeEditQueue === 0) {
                                this.reportToDateTimeChange(this.state.fromDateTime, toDateTime);
                            }
                        }
                    );
                }, 2000)
        );
    };

    onFromDateChange = (date: Moment) => {
        let currentTime = this.state.fromDateTime.format('HH:mm ZZ');
        let newFromDateTime = moment(date.format('D MMM yyyy') + ' ' + currentTime);
        if (!newFromDateTime || !newFromDateTime.isValid() || newFromDateTime > this.state.toDateTime) {
            return;
        }
        this.setState((prevState) => ({
            ...prevState,
            fromDateTime: newFromDateTime,
        }));
        this.reportFromDateTimeChange(newFromDateTime, this.state.toDateTime);
    };

    onToDateChange = (date: Moment) => {
        let currentTime = this.state.toDateTime.format('HH:mm ZZ');
        let newToDateTime = moment(date.format('D MMM yyyy') + ' ' + currentTime);
        if (!newToDateTime || !newToDateTime.isValid() || newToDateTime < this.state.fromDateTime) {
            return;
        }
        this.setState((prevState) => ({
            ...prevState,
            toDateTime: newToDateTime,
        }));
        this.reportFromDateTimeChange(this.state.fromDateTime, newToDateTime);
    };

    onInputTimeChange = (data: any) => {
        const time = {
            selectedTimeText: data.toString().trim(),
        };
        return time;
    };

    onFromTimeChange = (evt: any, data: any) => {
        if (data === null) {
            return;
        }
        const time = moment(data.selectedTimeText, 'HH:mm');
        let currentDate = this.state.fromDateTime.format('D MMM yyyy');
        let currentTimeZone = this.state.fromDateTime.format('ZZ');
        let newFromDateTime = moment(currentDate + ' ' + time.format('HH:mm') + ' ' + currentTimeZone);
        this.onFromDateTimeChange(newFromDateTime);
        const errorMessage = this.CheckTimeInput(data.errorType);
        this.setState({ fromTimeErrorMessage: errorMessage });
    };

    onToTimeChange = (evt: any, data: any) => {
        if (data === null) {
            return;
        }
        const time = moment(data.selectedTimeText, 'HH:mm');
        let currentDate = this.state.toDateTime.format('D MMM yyyy');
        let currentTimeZone = this.state.toDateTime.format('ZZ');
        let newToDateTime = moment(currentDate + ' ' + time.format('HH:mm') + ' ' + currentTimeZone);
        this.onToDateTimeChange(newToDateTime);
        const errorMessage = this.CheckTimeInput(data.errorType);
        this.setState({ toTimeErrorMessage: errorMessage });
    };

    CheckTimeInput = (error: string) => {
        switch (error) {
            case 'invalid-input':
                return 'Invalid time format. Please use the 24-hour format HH:MM.';
            case 'out-of-bounds':
                return 'Time out of the 0:00 to 24:00 range.';
            case 'required-input':
                return 'Time is required.';
            default:
                return '';
        }
    };

    setChecked = (period: any, selectedIndex: number) => {
        let fromDateTime = moment().subtract(period);
        let toDateTime = moment();
        this.forceUpdate();
        this.reportFacetChange(fromDateTime, toDateTime, selectedIndex);
    };

    setCustomChecked = () => {
        this.forceUpdate();
        this.reportFacetChange(this.state.fromDateTime, this.state.toDateTime, null);
    };

    render() {
        const periodData = this.props.periodData;
        let customChecked = true;
        let checkboxChecked = false;
        let periodCheckboxes = periodData.map((periodEntry, index) => {
            if (periodEntry.count <= 0 && periodEntry.showAlways === false) {
                return null;
            }
            if (periodEntry.checked) {
                checkboxChecked = true;
                customChecked = false;
            }
            let searching = false;
            if (this.props.isExecutingSearch) {
                searching = true;
            }
            
            const countDisplay = periodEntry.count && periodEntry.displaycount && !searching ? `(${periodEntry.count})` : '';
            const radioButtonItems = [
                {
                    key: periodEntry.periodIndex,
                    label: `${periodEntry.displayName} ${countDisplay}`,
                    value: periodEntry.periodIndex.toString(),
                },
            ];
            const isCheckedValue = periodEntry.checked ? periodEntry.periodIndex.toString() : '';
            return (
                <li key={index + 1}>
                    <RadioGroup layout="vertical" value={isCheckedValue} onChange={(_, options) => this.setChecked(periodEntry.period, periodEntry.periodIndex)}>
                        {radioButtonItems.map((item) => (
                            <Radio key={item.key} value={item.value} label={item.label} />
                        ))}
                    </RadioGroup>
                </li>
            );
        });
        const { handleSectionExpand, state } = this;
        const { isExpanded } = state;
        const startTime = moment();
        const remainder = startTime.minute() % 30;
        const toDateTimeDefault = moment(startTime).subtract(remainder, 'minutes').format('HH:mm');
        return (
            <section className={`search-fragment ${isExpanded ? 'expanded' : ''}`}>
                <header className={`${(checkboxChecked || customChecked) && 'active'}`} onClick={() => handleSectionExpand()}>
                    <Button appearance="transparent" icon={isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />} />
                    {this.props.displayName}
                </header>
                <div className="support-content">
                    <ul>
                        {periodCheckboxes}
                        <li key={periodCheckboxes.length + 1}>
                            <Radio value="Custom" label="Custom" checked={customChecked} onClick={this.setCustomChecked} />
                        </li>
                        <li key={1} className="display--flex date-time-support">
                            <p className="title">From</p>
                            <DatePicker
                                className="datepicker"
                                value={this.state.fromDateTime}
                                onChange={(newDate: Moment) => this.onFromDateChange(newDate)}
                                maxDate={this.state.toDateTime}
                                context={this.props.context}
                            />
                            <Field className="support-timepicker" validationMessage={this.state.fromTimeErrorMessage}>
                                <TimePicker
                                    className="time-input"
                                    expandIcon={<ShiftActivityIcon />}
                                    freeform
                                    style={{
                                        height: '28px',
                                        width: '200px',
                                        display: 'flex',
                                        minWidth: '100%',
                                    }}
                                    defaultValue="00:00"
                                    onTimeChange={this.onFromTimeChange}
                                />
                            </Field>
                        </li>
                        <li key={2} className="display--flex date-time-support">
                            <p className="title">To</p>
                            <DatePicker
                                value={this.state.toDateTime}
                                onChange={(newDate: Moment) => this.onToDateChange(newDate)}
                                minDate={this.state.fromDateTime}
                                maxDate={moment()}
                                context={this.props.context}
                            />
                            <Field className="support-timepicker" validationMessage={this.state.toTimeErrorMessage}>
                                <TimePicker
                                    className="time-input"
                                    expandIcon={<ShiftActivityIcon />}
                                    freeform
                                    style={{
                                        height: '28px',
                                        width: '200px',
                                        display: 'flex',
                                        minWidth: '100%',
                                    }}
                                    defaultValue={toDateTimeDefault}
                                    onTimeChange={this.onToTimeChange}
                                />
                            </Field>
                        </li>
                    </ul>
                </div>
            </section>
        );
    }
}

const TimeFacet = connectTeamsTheme(TimeFacetTemplate);
export default TimeFacet;
